<div
  #swiperContainer
  class="advertisement-slider swiper-container h-auto mb-xl-20 mb-md-40"
>
  <!-- Loading State -->
  <div *ngIf="isLoadingReviews" class="text-center" style="padding: 40px">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="text-light-black mt-2" style="font-size: 14px">
      Loading reviews...
    </p>
  </div>

  <!-- Reviews Slider -->
  <div
    *ngIf="!isLoadingReviews && topCustomerReviews.length > 0"
    class="swiper-wrapper"
  >
    <div *ngFor="let feedback of topCustomerReviews" class="swiper-slide">
      <div class="testimonial-wrapper">
        <div class="testimonial-box">
          <div class="testimonial-img p-relative">
            <a routerLink="/restaurant">
              <img
                [src]="getFirstServiceComboPhoto(feedback)"
                class="img-fluid full-width"
                alt="testimonial-img"
                style="
                  width: 100%;
                  height: 180px;
                  object-fit: cover;
                  display: block;
                "
                onerror="this.src='assets/img/nails-fallback.jpg'"
              />
            </a>
            <div class="overlay">
              <div class="brand-logo">
                <img
                  *ngIf="hasCustomerPhoto(feedback.customerPhotoUrl)"
                  [src]="feedback.customerPhotoUrl"
                  class="img-fluid rounded-circle"
                  style="width: 50px; height: 50px; object-fit: cover"
                  alt="{{ feedback.customerName }}"
                  onerror="this.src='assets/img/nails-fallback.jpg'"
                />
                <div
                  *ngIf="!hasCustomerPhoto(feedback.customerPhotoUrl)"
                  class="img-fluid rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                  style="width: 50px; height: 50px; font-size: 24px; flex-shrink: 0"
                >
                  {{ getCustomerInitial(feedback.customerName) }}
                </div>
              </div>
            </div>
          </div>
          <div class="testimonial-caption padding-15">
            <p class="text-light-white text-uppercase no-margin fs-12">
              Top Reviewer
            </p>
            <h5 class="fw-600">
              <a routerLink="/restaurant" class="text-light-black">
                {{
                  feedback.appointment?.storeInfo?.storeName || "Store Review"
                }}
              </a>
            </h5>
            <div class="testimonial-user-box" style="display: flex; gap: 10px;">
              <img
                *ngIf="hasCustomerPhoto(feedback.customerPhotoUrl)"
                [src]="feedback.customerPhotoUrl"
                class="rounded-circle"
                style="width: 40px; height: 40px; object-fit: cover"
                alt="{{ feedback.customerName }}"
              />
              <div
                *ngIf="!hasCustomerPhoto(feedback.customerPhotoUrl)"
                class="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                style="width: 40px; height: 40px; font-size: 16px; flex-shrink: 0"
              >
                {{ getCustomerInitial(feedback.customerName) }}
              </div>
              <div class="testimonial-user-name">
                <p class="text-light-black fw-600">
                  {{ feedback.customerName }}
                </p>
                <i
                  *ngIf="feedback.hasHeart"
                  class="fas fa-trophy text-black"
                ></i>
                <span *ngIf="feedback.hasHeart" class="text-light-black"
                  >Top Reviewer</span
                >
              </div>
            </div>
            <div class="ratings">
              <span [class.text-primary]="true" class="fs-16">
                <i class="fas fa-heart"></i>
              </span>
            </div>
            <p class="text-light-black">
              {{ getFeedbackCommentPreview(feedback.comment) }}
            </p>
            <p class="text-light-white fw-100">
              <strong class="text-light-black fw-700">Review Date: </strong>
              {{ formatFeedbackDate(feedback.createdTime) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No Reviews -->
  <div
    *ngIf="!isLoadingReviews && topCustomerReviews.length === 0"
    class="text-center"
    style="padding: 40px"
  >
    <p class="text-light-black">No reviews available yet.</p>
  </div>

  <!-- Add Arrows (only show if there are reviews) -->
  <div
    *ngIf="!isLoadingReviews && topCustomerReviews.length > 1"
    class="swiper-button-next"
  ></div>
  <div
    *ngIf="!isLoadingReviews && topCustomerReviews.length > 1"
    class="swiper-button-prev"
  ></div>
</div>
